import type { TFunction } from "i18next"

import { ErrorCode } from "@/constants/errors"

export interface ApiErrorWithData {
  response?: {
    status?: number
  }
  data?: {
    error_code?: number
    message?: string
  }
}

export function getAuthErrorMessage(
  error: unknown,
  t: TFunction,
  fallbackKey: string
): string {
  const apiError = error as ApiErrorWithData
  if (apiError.response?.status === 429) {
    return t("common.auth.errors.tooManyRequests")
  }
  return apiError.data?.message || t(fallbackKey)
}

export function getAuthPasswordErrorMessage(
  error: unknown,
  t: TFunction,
  fallbackKey: string
): string {
  const apiError = error as ApiErrorWithData
  const errorData = apiError.data
  if (apiError.response?.status === 429) {
    return t("common.auth.errors.tooManyRequests")
  }
  if (errorData?.error_code === ErrorCode.AUTH_PASSWORD_REUSED) {
    return t("common.auth.errors.passwordUnchanged")
  }
  if (errorData?.error_code === ErrorCode.AUTH_EMAIL_ALREADY_REGISTERED) {
    return t("common.auth.signup.errors.emailAlreadyRegistered")
  }
  if (errorData?.error_code === ErrorCode.SYS_VALIDATION_ERROR) {
    return t("common.auth.errors.passwordPolicy")
  }
  return getAuthErrorMessage(error, t, fallbackKey)
}
